<script setup>
import { computed } from 'vue'
import { useAuthUserStore } from '@/stores/auth';

const auth = useAuthUserStore();

const props = defineProps({
    is: {
        type: [Array, String],
        default: 'standard-user'
    },
    can: {
        type: [Array, String],
        default: ''
    },
    isNot: {
        type: [Array, String],
        default: ''
    },
    canNot: {
        type: [Array, String],
        default: ''
    }
})

// Wrap in computed so visible re-evaluates if auth state changes in the same SPA session
// (e.g. logout → re-login without a full reload). Accessing auth.getUserRole directly
// returns the current string value — not a ref — breaking reactivity tracking.
const role = computed(() => auth.getUserRole)

function normalize(search) {
    return Array.isArray(search) ? search : search ? [search] : [];
}

function allow(search) {
    const list = normalize(search);
    return list.length === 0 || list.includes(role.value);
}

function deny(search) {
    const list = normalize(search);
    return list.length === 0 || !list.includes(role.value);
}

const visible = computed(() =>
    allow(props.is) &&
    allow(props.can) &&
    deny(props.isNot) &&
    deny(props.canNot)
)

</script>
<template>
    <template v-if="visible">
        <slot></slot>
    </template>
</template>
